import React from "react";
import localeText from "../../../locale";

const ConfimeaContact = () => {
  return (
    <section id="contact" className="confimea-contact-section">
      <div className="confimea-container">
        <div className="confimea-contact-inner">
          <div className="confimea-contact-icon">
            <i className="pi pi-question-circle" style={{ color: "#ffffff", fontSize: "28px" }}></i>
          </div>
          <div className="confimea-contact-title">{localeText("contactTitle")}</div>
          <p className="confimea-contact-text">{localeText("contactText")}</p>
          <div className="confimea-contact-buttons">
            <a href="#form" className="confimea-btn confimea-btn-primary">
              {localeText("contactButton1")}
            </a>
            <a
              href="https://wa.me/+393517670019"
              target="_blank"
              rel="noopener noreferrer"
              className="confimea-contact-email"
            >
              <i
                className="pi pi-whatsapp mr-2"
                style={{ color: "rgba(32, 140, 86, 1)", fontSize: "1rem" }}
              ></i>
              +39 351 767 0019
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConfimeaContact;
